import { useUserInfo } from "GlobalStates/User";
export const UserWelcomeTitle = () => {
  const { user } = useUserInfo();
  return (
    <div className="mb-3 text-center">
      <h1 className="text-3xl md:text-5xl font-bold text-slate-900 leading-tight">
        Welcome back,{" "}
        <span className="bg-gradient-to-r from-emerald-600 to-green-600 bg-clip-text text-transparent text-3xl md:text-5xl font-bold text-slate-900 leading-tight">
          {user.name.charAt(0).toUpperCase() + user.name.slice(1) + "!"}
        </span>
      </h1>
    </div>
  );
};

